import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const sections = document.querySelectorAll(".section-scrollTrigger");

function animationTitle(section) {
    const titles = section.querySelectorAll(".animation-title");
    titles.forEach(title => {
        if (!title) return;

        const split = new SplitText(title, { type: "lines" });
        const lines = split.lines;

        gsap.set(title, { opacity: 1 });
        lines.forEach((line, index) => {
            gsap.fromTo(line,
                {
                    yPercent: 100,
                    opacity: 0
                },
                {
                    yPercent: -10,
                    opacity: 1,
                    ease: "cubic-bezier(0.25, 1, 0.5, 1)",
                    duration: 0.5,
                    delay: index * 0.12,
                    onComplete: () => {
                        gsap.to(line, {
                            yPercent: 0,
                            ease: "cubic-bezier(0.25, 1, 0.5, 1)",
                            duration: 0.3
                        });
                    }
                }
            );
        });
    });
}

function items_on_screen() {
    sections.forEach(section => {
        if (ScrollTrigger.isInViewport(section) && !section.classList.contains("visible")) {
            section.classList.add("visible");

            setTimeout(() => {
                animationTitle(section);
            }, 500);
        }
    });
}

ScrollTrigger.create({
    start: 0,
    end: "max",
    onUpdate: () => {
        items_on_screen();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    items_on_screen();
});